"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.integrationDatabasesApi = exports.getLogs = exports.updateDatabaseExport = exports.createExport = exports.createInstance = exports.deleteDatabaseExport = exports.checkDestination = exports.deleteInstance = exports.updateInstance = exports.getInstanceById = exports.getAll = void 0;
const createApi_1 = require("../../helpers/createApi");
const getAll = (caller) => ({ accountId }) => {
    return caller(`/${accountId}/integration-databases`).get();
};
exports.getAll = getAll;
const getInstanceById = (caller) => ({ accountId, integrationId }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}`).get();
};
exports.getInstanceById = getInstanceById;
const updateInstance = (caller) => ({ accountId, integrationId, instanceId, content }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances/${instanceId}`).patch(content);
};
exports.updateInstance = updateInstance;
const deleteInstance = (caller) => ({ accountId, integrationId, instanceId }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances/${instanceId}`).delete();
};
exports.deleteInstance = deleteInstance;
const checkDestination = (caller) => ({ accountId, integrationId, content }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/check-destination`).post(content.configs);
};
exports.checkDestination = checkDestination;
const deleteDatabaseExport = (caller) => ({ accountId, integrationId, exportId, instanceId }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances/${instanceId}/exports/${exportId}`).delete();
};
exports.deleteDatabaseExport = deleteDatabaseExport;
const createInstance = (caller) => ({ accountId, integrationId, content }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances`).post(content);
};
exports.createInstance = createInstance;
const createExport = (caller) => ({ accountId, integrationId, instanceId, content }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances/${instanceId}/exports`).post(content);
};
exports.createExport = createExport;
const updateDatabaseExport = (caller) => ({ accountId, integrationId, exportId, instanceId, content }) => {
    return caller(`/${accountId}/integration-databases/${integrationId}/instances/${instanceId}/exports/${exportId}`).patch(content);
};
exports.updateDatabaseExport = updateDatabaseExport;
const getLogs = (caller) => ({ accountId, databaseId, startDate, endDate, search, page, perPage, connectorIds, exportId }) => {
    return caller(`/${accountId}/integration-databases/${databaseId}/logs`).get({
        start_date: startDate,
        end_date: endDate,
        search,
        page,
        per_page: perPage,
        connector_ids: connectorIds,
        export_id: exportId,
    });
};
exports.getLogs = getLogs;
exports.integrationDatabasesApi = (0, createApi_1.createAPIFactory)({
    getAll: exports.getAll,
    getInstanceById: exports.getInstanceById,
    updateInstance: exports.updateInstance,
    checkDestination: exports.checkDestination,
    deleteInstance: exports.deleteInstance,
    deleteDatabaseExport: exports.deleteDatabaseExport,
    createInstance: exports.createInstance,
    createExport: exports.createExport,
    updateDatabaseExport: exports.updateDatabaseExport,
    getLogs: exports.getLogs,
});
//# sourceMappingURL=api.js.map